import { Component, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  ApiUserMgmt,
  KeycloakRoleControllerService,
  UserRoleEntityDTO,
  KeycloakRoleDTO,
  KeycloakUserDTO,
  EntidadAsociadaDTO,
  KeycloakUserFilterDTO,
  PageDTOKeycloakUserDTO,
  UserManagementControllerService,
  DiccionarioElementoDTO,
  DiccionarioControllerService,
} from 'api-rest';
import { ComboService, Combo } from '../../../services/combo.service';
import { DownloadService } from '../../../services/download.service';
import {
  UserDetailModalComponent,
  UserDetailModalData,
} from '../../components/user-detail-modal/user-detail-modal.component';
import { MappedResponse } from '../../../share/components/ge-select-pagination/ge-select-pagination.component';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { SnackbarService } from '../../../services/snackbar.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'lib-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss'],
})
export class UserSearchComponent implements OnDestroy {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  roles: KeycloakRoleDTO[] = [];
  adheridosEndpoint =
    this.environment.urlBackAdheridos + 'api/v1/adheridos/adheridos/listar-todos';
  poseedoresEndpoint =
    this.environment.urlBackPoseedores + 'api/v1/poseedores/poseedor';
  gestoresResiduosEndpoint =
    this.environment.urlBackPoseedores + 'api/v1/poseedores/gestores-residuos';
  puntosRecogidaEndpoint =
    this.environment.urlBackPuntoRecogida +
    'api/v1/puntos-recogida/puntosrecogida';
  gestorPuntosRecogidaEndpoint =
    this.environment.urlBackPuntoRecogida +
    'api/v1/puntos-recogida/gestorptorecogida';
    gestorAcuerdoIndirectoEndpoint =
    this.environment.urlBackAcuerdoIndirecto +
    'api/v1/acuerdo-indirecto/acuerdo-indirecto';
  entidadAdociadaEndpoint = '';
  defaultFilter: boolean = true;
  userTypes: Combo[] = [];
  UserTypeEnum = UserRoleEntityDTO.EntityTypeEnum;

  headArray: any = [
    {
      Head: 'Nombre',
      FieldName: 'firstName',
    },
    {
      Head: 'Apellidos',
      FieldName: 'lastName',
    },
    {
      Head: 'Email',
      FieldName: 'email',
    },
    {
      Head: 'Roles por Entidad',
      FieldName: 'activeUserRolesEntitiesDetail',
      Tooltip: true,
    },
    {
      Head: 'Activo',
      FieldName: 'enabled',
      renderValue: (item: KeycloakUserDTO) => (item.enabled ? 'SI' : 'NO'),
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'edit', icon: 'open_in_new', toolTip: 'Editar' },
        // { 'nameButton': "delete", "icon": "delete", 'toolTip': 'Borrar' },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'reset-password',
              icon: 'cached',
              toolTip: 'Reestablecer contraseña',
              name: 'Reestablecer contraseña',
            },
            {
              nameButton: 'enable',
              icon: 'how_to_reg',
              toolTip: 'Habilitar usuario',
              name: 'Habilitar usuario',
              show: (item: KeycloakUserDTO) => !item.enabled,
            },
            {
              nameButton: 'disable',
              icon: 'person_off',
              toolTip: 'Deshabilitar usuairo',
              name: 'Deshabilitar usuario',
              show: (item: KeycloakUserDTO) => item.enabled,
            },
          ],
        },
      ],
      width: '8',
      permanent: true,
    },
  ];
  gridArray: KeycloakUserDTO[] = [];

  searchForm: FormGroup;
  subscriptions: Subscription[] = [];
  flagSearch: boolean = false;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  updateList = false;
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    private userService: UserManagementControllerService,
    private roleService: KeycloakRoleControllerService,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public comboService: ComboService,
    private downloadService: DownloadService,
    private snackbarService: SnackbarService,
    private diccionarioControllerService: DiccionarioControllerService,
        @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService
  ) {
    this.searchForm = this.formBuilder.group({
      firstName: [{ value: null, disabled: false }],
      lastName: [{ value: null, disabled: false }],
      email: [{ value: null, disabled: false }],
      userRole: [{ value: null, disabled: false }],
      userType: [{ value: null, disabled: false }],
      entidadAsociada: [{ value: null, disabled: false }],
      enabled: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit(): void {
    this.userTypes = this.comboService.getUserTypes();
    this.roleService.getRealRoles().subscribe((res) => (this.roles = res));

    const subscription = this.searchForm.controls[
      'userType'
    ].valueChanges.subscribe((val) => this.onUserTypeChange(val));
    this.subscriptions.push(subscription);
    this.onUserTypeChange();
    this.comboOrden();
  }

  comboOrden() {
    this.diccionarioControllerService.listarElementos(['ORDEN_ADMIN_USUARIOS_BUSQUEDA']).subscribe((res) => {
      this.orden = res['ORDEN_ADMIN_USUARIOS_BUSQUEDA'];
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  onUserTypeChange(val?: UserRoleEntityDTO.EntityTypeEnum) {
    this.searchForm.controls['entidadAsociada'].patchValue(null);
    if (val == this.UserTypeEnum.Adherido) {
      this.entidadAdociadaEndpoint = this.adheridosEndpoint;
      this.searchForm.controls['entidadAsociada'].enable();
      this.updateList = false;
      this.updateList = true;
    } else if (val == this.UserTypeEnum.Poseedor) {
      this.entidadAdociadaEndpoint = this.poseedoresEndpoint;
      this.searchForm.controls['entidadAsociada'].enable();
      this.updateList = false;
      this.updateList = true;
    } else if (val == this.UserTypeEnum.GestorPoseedor) {
      this.entidadAdociadaEndpoint = this.gestoresResiduosEndpoint;
      this.searchForm.controls['entidadAsociada'].enable();
      this.updateList = false;
      this.updateList = true;
    } else if (val == this.UserTypeEnum.PuntoRecogida) {
      this.entidadAdociadaEndpoint = this.puntosRecogidaEndpoint;
      this.searchForm.controls['entidadAsociada'].enable();
      this.updateList = false;
      this.updateList = true;
    } else if (val == this.UserTypeEnum.GestorPuntoRecogida) {
      this.entidadAdociadaEndpoint = this.gestorPuntosRecogidaEndpoint;
      this.searchForm.controls['entidadAsociada'].enable();
      this.updateList = false;
      this.updateList = true;
    }else if (val == this.UserTypeEnum.AcuerdoIndirecto) {
      this.entidadAdociadaEndpoint = this.gestorAcuerdoIndirectoEndpoint;
      this.searchForm.controls['entidadAsociada'].enable();
      this.updateList = false;
      this.updateList = true;
    }else {
      this.searchForm.controls['entidadAsociada'].disable();
    }
  }

  renderPage(event: number) {
    this.pageNumber = event;
    this.getUsers();
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  checked(item: any) { }

  searchData() {
    this.pageNumber = 1;
    this.getUsers();
  }

  getUsers() {
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();

    this.userService
      .getUsuarios(backendFilter, {
        page: page,
        size: size,
        sort: ['firstName,asc'],
      },
        orden,
        tipoOrden
)
      .pipe()
      .subscribe({
        next: (data: PageDTOKeycloakUserDTO) => {
          if (data) {
            this.gridArray = data.datos ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
          }
          this.flagSearch = this.gridArray.length > 0;
        },
        error: (error) => {
          // TODO: Mostrar error
        },
      });
  }

  private getBackendFilter() {
    const textFilter = (value: any) =>
      value?.trim() ? value?.trim() : undefined;
    const filter = this.searchForm.value;

    // if (filter.entidadAsociada) {
    //   filter.entidadAsociada = {
    //     id: filter.entidadAsociada.id
    //   };
    // }

    if (filter.enabled == false) {
      delete filter.enabled;
    }

    const backendFilter: KeycloakUserFilterDTO = {
      firstName: textFilter(filter.firstName),
      lastName: textFilter(filter.lastName),
      email: textFilter(filter.email?.trim()),
      enabled: filter.enabled,
    };

    if (filter.userRole) {
      backendFilter.userRolesEntities = {
        role: {
          name: filter.userRole,
        },
        enabled: true,
      };
    }

    if (filter.userType) {
      backendFilter.userRolesEntities = backendFilter.userRolesEntities ?? {
        enabled: true,
      };
      backendFilter.userRolesEntities.entityType = filter.userType;
    }

    if (filter.entidadAsociada?.id) {
      backendFilter.userRolesEntities = backendFilter.userRolesEntities ?? {
        enabled: true,
      };
      backendFilter.userRolesEntities.entity =
        backendFilter.userRolesEntities.entity ?? {};
      backendFilter.userRolesEntities.entity.id = filter.entidadAsociada.id;
    }

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    const params = {
      filtro: backendFilter,
      page: page,
      size: this.pageSize,

    };
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  action(item: any) {
    if (item.nameButton == 'edit') {
      this.openModalUser(item, true);
    } else if (item.nameButton == 'reset-password') {
      this.confirmacion(
        `¿Desea re-establecer la contraseña del usuario ${item.firstName} ${item.lastName}?`,
        () => this.resetPassword(item)
      );
    } else if (item.nameButton == 'enable') {
      this.confirmacion(
        `¿Desea habilitar el usuario ${item.firstName} ${item.lastName}?`,
        () => this.habilitarUsuario(item)
      );
    } else if (item.nameButton == 'disable') {
      this.confirmacion(
        `¿Desea deshabilitar el usuario ${item.firstName} ${item.lastName}?`,
        () => this.deshabilitarUsuario(item)
      );
    } else if (item.nameButton == 'delete') {
      this.confirmacion(
        `¿Desea eliminar el usuario ${item.firstName} ${item.lastName}?`,
        () => this.eliminarUsuario(item)
      );
    }
  }

  openModalUser(element?: any, editMode = false): void {
    const dialogRef = this.dialog.open(UserDetailModalComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: <UserDetailModalData>{
        user: element,
        editMode,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getUsers();
      }
    });
  }

  confirmacion(titulo: string, callBack: Function): void {
    Swal.fire({
      text: titulo,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        callBack();
      }
    });
  }

  habilitarUsuario(user: KeycloakUserDTO) {
    this.userService.habilitarPorId(user.keycloakId!).subscribe({
      next: (response) => {
        this.snackbarService.showSnackBar(
          'El usuario se ha habilitado correctamente',
          'success'
        );
        this.getUsers();
      },
      error: (err) => {
        this.snackbarService.showSnackBar(
          'Ha ocurrido un error al habilitar el usuario',
          'error'
        );
      },
    });
  }

  deshabilitarUsuario(user: KeycloakUserDTO) {
    this.userService.deshabilitarPorId(user.keycloakId!).subscribe({
      next: (response) => {
        this.snackbarService.showSnackBar(
          'El usuario se ha deshabilitado correctamente',
          'success'
        );
        this.getUsers();
      },
      error: (err) => {
        this.snackbarService.showSnackBar(
          'Ha ocurrido un error al deshabilitar el usuario',
          'error'
        );
      },
    });
  }

  eliminarUsuario(item: any) {
    this.userService.eliminarUsuarioPorId(item.keycloakId).subscribe({
      next: (response) => {
        this.snackbarService.showSnackBar(
          'El usuario se ha eliminado correctamente',
          'success'
        );
        this.getUsers();
      },
      error: (err) => {
        this.snackbarService.showSnackBar(
          'Ha ocurrido un error al eliminar el usuario',
          'error'
        );
      },
    });
  }

  private resetPassword(item: any) {
    this.userService.restorePassword(item.keycloakId).subscribe({
      next: (response) => {
        this.snackbarService.showSnackBar(
          'La contraseña del usuario se ha re-establecido correctamente',
          'success'
        );
        this.getUsers();
      },
      error: (err) => {
        this.snackbarService.showSnackBar(
          'Ha ocurrido un error al intentar re-establecer la contraseña del usuario',
          'error'
        );
      },
    });
  }

  clearSearcher() {
    this.searchForm.reset();
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => v !== filtro.value);
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 1;
    //this.getUsers();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const firstName = this.searchForm.get('firstName')?.value;
    if (firstName?.trim()) filtros.push({ label: `${firstName.trim()}`, campo: 'firstName' });

    const lastName = this.searchForm.get('lastName')?.value;
    if (lastName?.trim()) filtros.push({ label: `${lastName.trim()}`, campo: 'lastName' });

    const email = this.searchForm.get('email')?.value;
    if (email?.trim()) filtros.push({ label: `${email.trim()}`, campo: 'email' });

    const userRole = this.searchForm.get('userRole')?.value;
    if (userRole) filtros.push({ label: `${userRole}`, campo: 'userRole' });

    const userType = this.searchForm.get('userType')?.value;
    if (userType) {
      const found = this.userTypes.find((item: Combo) => item.id === userType);
      filtros.push({
        label: `${found ? this.separarCamelCase(found.name) : String(userType)}`,
        campo: 'userType',
      });
    }

    const entidadAsociada = this.searchForm.get('entidadAsociada')?.value;
    if (entidadAsociada) {
      filtros.push({
        label: `Entidad asociada: ${this.getEntidadAsociadaDescription(entidadAsociada)}`,
        campo: 'entidadAsociada',
      });
    }

    const enabled = this.searchForm.get('enabled')?.value;
    if (enabled === true) filtros.push({ label: 'Activo: Sí', campo: 'enabled' });

const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.userService.exportCSV(backendFilter, 'response').subscribe((res) => {
      this.downloadService.exportModal();
      // const filename = this.downloadService.getFileName(
      //   res.headers,
      //   'Exportacion_Adheridos.csv'
      // );
      // this.downloadService.downloadCSV(res.body!, filename!);
    });
  }

  exportarPdf() {
    // TODO: Implementar export excel
  }

  mapAdheridosReponse(response: any): MappedResponse<any> {
    return {
      datos: response?.datos,
      recordsFiltered: response.recordsTotal,
      totalElements: response.totalElements,
    };
  }

  getEntidadAsociadoFormControl(): FormControl<any> {
    return this.searchForm.controls['entidadAsociada'] as FormControl<any>;
  }

  separarCamelCase(texto: string) {
    return texto.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
  
  getEntidadAsociadaDescription = (object: any): string => {
    const userType = this.searchForm.get('userType')?.value
    if (
      userType === this.UserTypeEnum.Poseedor

    ) {
      return object?.razonSocial + ' - ' + object?.denominacionCentro;
    } else if (
      userType === this.UserTypeEnum.PuntoRecogida ||
      userType === this.UserTypeEnum.GestorPuntoRecogida
    ) {
      return object?.razonSocial + ' - ' + object?.denominacion;

    } else if (
      userType === this.UserTypeEnum.GestorPoseedor
    ) {
      return object?.razonSocial + ' - ' + object?.centro;

    } else {
      return object?.razonSocial;
    }
  }
   canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    } 
}
